export class MockPaymentAccount {
    constructor() {
        this.cache = {
            testelouis: {
                owner: 'luizg%40take.net@blip.ai',
                paymentAccount: 'luizg%40take.net@blip.ai',
            },
            bliptestcards: {
                owner: 'teste%40take.net@blip.ai',
                paymentAccount: 'luizg%40takenet.com.br@blip.ai',
            },
            testezendeskbug: {
                owner: 'teste%40take.net@blip.ai',
                paymentAccount: 'teste%40take.net@blip.ai',
            },
            botastral: {
                owner: 'luizg%40take.net@blip.ai',
                paymentAccount: 'teste%40take.net@blip.ai',
            },
            botdeatendimentohmg: {
                owner: 'luizg%40take.net@blip.ai',
                paymentAccount: 'luizg%40takenet.com.br@blip.ai',
            },
        };
    }
    set(key, value) {
        this.cache[key] = value;
    }
    get(key) {
        return this.cache[key];
    }
    delete(key) {
        delete this.cache[key];
    }
}
